var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("avue-input-tree", {
    attrs: {
      "default-expand-all": "",
      placeholder: _vm.placeholder,
      dic: _vm.data,
      props: _vm.props,
    },
    model: {
      value: _vm.bindValue,
      callback: function ($$v) {
        _vm.bindValue = $$v
      },
      expression: "bindValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }